import React, { useState, useRef, useEffect } from 'react';
import { AudioRecorder, useAudioRecorder } from 'react-audio-voice-recorder';
import HamsterAnimation from '../animation/loader';
import { withAuthenticationRequired,useAuth0 } from '@auth0/auth0-react';
import Transcript from './transcript';
import ShareToWhatsApp from './ShareToWhatsApp';
 
const MultipleFileUpload = () => {
  //const [files, setFiles] = useState({ file_one: null, file_two: null, file_three: null });
  const [chatResponse, setChatResponse] = useState(''); // Add a new state variable for the chat response
  const [chatResponse2, setchatResponse2] = useState('');
  const [concatenatedResponse, setConcatenatedResponse] = useState('');
  const editedContentRef = useRef('');

  const [procedurResponse, setProcedureResponse] = useState('');
  const [audioURL, setAudioURL] = useState(null); // Add a new state variable for the audio URL
  const recorderControls = useAudioRecorder();
  const { getAccessTokenSilently, user} = useAuth0();
  const [userStatus, setUserStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { name } = user;
  const pRef = useRef(null);
  const undo = () => {
    if (pRef.current) {
      pRef.current.innerHTML = chatResponse;
    }
  };
  const [isEditing, setIsEditing] = useState(false);



  



  const onRecordingComplete = async (blob) => {
    setAudioURL(URL.createObjectURL(blob)); // Set the audio URL so the user can listen to the recording
  };

  const sendRecording = async () => {
    setIsLoading(true);
    const blob = await fetch(audioURL).then(r => r.blob());
  const formData = new FormData();
  const filename = `${name}-recording.webm`;
  // Convert blob to File
  const file = new File([blob], filename, {
    type: "audio/webm",
  });
    formData.append('avatar', file);
    console.log(file);
    // Rest of your fetch code here...
    try {
      const token = await getAccessTokenSilently();
        //const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/upload`, {
          const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/upload_audio`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });
  
        if (!response.body) {
          throw Error('Unsupported Response');
        }
        
        const reader = response.body.getReader();
        let chunks = '';
        while (true) {
          const { done, value } = await reader.read();
          if (done) {
            console.log('Completed');
            break;
          }
          chunks += new TextDecoder("utf-8").decode(value);
          //console.log(chunks);
          setChatResponse(chunks.replace(/\n/g, '<br/>')); // Update the chatResponse state variable with the server's response
        }
      } catch(err) {
        console.log(err);
        setChatResponse("ERROR INESPERADO EN EL SERVIDOR, INTENTE ENVIAR AUDIO DE NUEVO")
      }
      finally {
        setIsLoading(false);
      }
  };
  const finalizeEdit = () => {
    if (pRef.current) {
      const updatedContent = pRef.current.innerHTML.replace(/<br\/>/g, '\n');
      setChatResponse(updatedContent);
      //console.log(updatedContent);
    }
  };

  


  useEffect(() => {
    setConcatenatedResponse(`${chatResponse} ${chatResponse2} ${procedurResponse}`);
    console.log(concatenatedResponse);
  }, [chatResponse, chatResponse2, procedurResponse,editedContentRef.current]);


  return (
    
    <div>
      <h1>Record Operatorio</h1>
      <div className='wrapper'>
        
      

      <div className='content-section'>
      <h3 className='parah1n1'>Hallazgos, Participantes, etc</h3>
      {isLoading && <HamsterAnimation />}
      <div className='apps-card'>
        
      <div className="app-card2">
        <span>Record audio:</span>
        <div className='content-section'>
        <AudioRecorder 
            onRecordingComplete={(blob) => onRecordingComplete(blob)}
            recorderControls={recorderControls}
            downloadOnSavePress={false}
            downloadFileExtension="webm"
            showVisualizer={true}
            audioTrackConstraints={{
              autoGainControl: true,
              echoCancellation: true,
              noiseSuppression: true,
            }}
            classes={{
              root: 'audio-recorder-root',
              controls: 'audio-recorder-controls',
              visualizer: 'audio-recorder-visualizer',
            }}
          />  
        
      </div>
      <div className='content-section'>
      {audioURL && (
        <div className="audio-controls">
          
          <audio src={audioURL} controls />
          <button className="send-recording-btn" onClick={sendRecording}>Send recording</button>
        </div>
      )}
      </div>
      </div> 


      <div className="app-card2">
      <span>Transcripcion:</span>
        <div className='transcription'>
        
        <p className="app-card2__subtext" 
          contentEditable={isEditing} 
          ref={pRef}
            dangerouslySetInnerHTML={{ __html: chatResponse }}
            ></p> 
            {isEditing && (
              <button className='content-button' onClick={undo}>
                ↺ 
              </button>
            )}
          <button className={isEditing ? 'content-button-logout':'content-button-login'} onClick={() => {
                if (isEditing) {
                  finalizeEdit();
                }
                setIsEditing(!isEditing);
              }}>
              {isEditing ? 'Finalizar' : 'Editar'}
          </button>

        </div>
      </div> 
    
      </div>
      <div className='content-section'></div>
      <h3 className='parah1n1'>Transcripción Directa y Sintesis</h3>
      <Transcript chatResponse2={chatResponse2} 
                                setchatResponse2={setchatResponse2} 
                                procedurResponse={procedurResponse}
                                setProcedureResponse={setProcedureResponse} 
                                chatResponse={chatResponse}/>
      </div>
      
      </div>
      </div>
    
  );
};

export default MultipleFileUpload;
